export function getSafeRedirect(raw: string | null | undefined, fallback: string): string {
  if (!raw) return fallback
  try {
    const resolved = new URL(raw, 'http://internal.local')
    if (resolved.origin !== 'http://internal.local') return fallback
    return resolved.pathname + resolved.search + resolved.hash
  } catch {
    return fallback
  }
}
